import { render, staticRenderFns } from "./AppJobItem.vue?vue&type=template&id=83486ee2&scoped=true&"
import script from "./AppJobItem.vue?vue&type=script&lang=js&"
export * from "./AppJobItem.vue?vue&type=script&lang=js&"
import style0 from "./AppJobItem.vue?vue&type=style&index=0&id=83486ee2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83486ee2",
  null
  
)

export default component.exports